export default Object.freeze({
  Payable: 1,
  OmittedActorSuspended: 2,
});
